import type { AccessRole } from "~/utils/effectiveAccess";

import { isSuperAdminRole } from "./roleRung";

/**
 * A role named from its parts: the super rung on its own, else the place's
 * display name with the persona or capability held there.
 */
export const roleLabelOf = (
  role: AccessRole,
  placeDisplayName: string | undefined,
  translate: (key: string, options?: Record<string, string>) => string,
): string => {
  if (role.capability === "super") {
    return translate(
      isSuperAdminRole(role) ? "super.super-admin" : "super.super-user",
    );
  }
  const word = translate(
    role.persona ? `persona.${role.persona}` : `capability.${role.capability}`,
  );
  const held = word.charAt(0).toUpperCase() + word.slice(1);
  return placeDisplayName
    ? translate("roleAtPlace", { place: placeDisplayName, role: held })
    : held;
};
